import React, { Component } from 'react';
import { Row, Col, Card } from 'antd';
import PropTypes from 'prop-types'; // ES6

import { configuracioScrollIntoView } from '../../constants';
import ObservacioDadesEstacio from './observacioDadesEstacio';
import ObservacioDetallSeccioVariables from './observacioDetallSeccioVariables';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

class ObservacioDetall extends Component {

    componentDidMount() {
        if (this.obsDetall.scrollIntoView) {
            this.obsDetall.scrollIntoView(configuracioScrollIntoView);
        }
    }

    componentDidUpdate() {
        if (this.obsDetall.scrollIntoView) {
            this.obsDetall.scrollIntoView(configuracioScrollIntoView);
        }
    }

    render() {
        const { observacio } = this.props;

        const estacio = observacio.estacio;
        const variables = observacio.grupsVariables;

        return (
            <Row className='observacio-detall'>
                <Col span={24}>
                    <Card className='camp' bordered={false}>
                        <div ref={ref => this.obsDetall = ref}>
                            <ObservacioDadesEstacio estacio={estacio} />
                            <ObservacioDetallSeccioVariables variables={variables} />
                        </div>
                    </Card>
                </Col>
            </Row>
        );
    }
}

ObservacioDetall.propTypes = {
    observacio: PropTypes.object
};

export default errorBoundaryWrapper(ObservacioDetall);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioDetall.js